import type React from "react";
import { UI_ICONS } from "../../../icons";

interface PreferenceDataTabProps {
	onExport: () => void;
	onOpenImport: () => void;
	onImport: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PreferenceDataTab: React.FC<PreferenceDataTabProps> = ({
	onExport,
	onOpenImport,
	onImport,
}) => {
	return (
		<div className="flex flex-col gap-8">
			<h3 className="m-0 mb-4 text-[1.1rem] text-primary border-b border-border-main pb-2">
				データ管理
			</h3>
			<p className="mb-6 opacity-80 text-sm">
				設定やセッション履歴のバックアップと復元を行えます。
			</p>
			<p className="mb-6 opacity-80 text-xs">
				セキュリティ上の理由により、エクスポートJSONにAPIキーは含まれません。
			</p>
			<div className="flex gap-3 flex-wrap">
				<button
					type="button"
					className="bg-transparent border border-border-main text-text-dim px-4 py-2 rounded-md cursor-pointer transition-all hover:border-text-dim hover:text-text-main focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none inline-flex items-center gap-2 active:scale-95"
					onClick={onExport}
				>
					{UI_ICONS.EXPORT} 全データを保存 (JSON)
				</button>
				<button
					type="button"
					className="bg-transparent border border-border-main text-text-dim px-4 py-2 rounded-md cursor-pointer transition-all hover:border-text-dim hover:text-text-main focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none inline-flex items-center gap-2 active:scale-95"
					onClick={onOpenImport}
				>
					{UI_ICONS.IMPORT} データを復元 (JSON)
				</button>
				<input
					id="import-input"
					type="file"
					accept=".json"
					className="hidden"
					onChange={onImport}
				/>
			</div>
		</div>
	);
};
